export const ROUTER_FAQ_LIST = '/content/help-center'
export const ROUTER_FAQ_ADD_OR_UPDATE = '/content/help-center/add-or-update'
export const ROUTER_FAQ_VIEW = '/content/help-center/detail'
